import { Link } from "react-router-dom";
import { useContext } from "react";
import { PropContext } from "./PropContext";
import { ListGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouse,
  faFolder,
  faMusic,
  faBook,
  faGamepad,
  faFilm,
  //faCalendar,
  faAddressCard,
} from "@fortawesome/free-solid-svg-icons";

import { getAssetTitle } from "../util/api.mjs";

//Renders the nav links of nav
export default function Navbar() {
  const { handleSelectPath, isTablet, handleFocus } = useContext(PropContext);

  const links = [
    { title: "Home", icon: faHouse },
    { title: "Portfolio", icon: faFolder },
    { title: "Books", icon: faBook },
    { title: "Music", icon: faMusic },
    { title: "Games", icon: faGamepad },
    { title: "Movies Tv", icon: faFilm },
    // { title: "Calendar", icon: faCalendar },
    { title: "Contact Me", icon: faAddressCard },
  ];
  return links.map((link) => {
    const pathName = `${link.title.replaceAll(" ", "_").toLowerCase()}`;

    return (
      <OverlayTrigger
        overlay={
          <Tooltip id={`${pathName}_tooltip`}>
            {getAssetTitle(pathName)}
          </Tooltip>
        }
        key={`nav_${pathName}`}
        data-test="nav-tooltip"
      >
        {link.title === "Home" ? (
          <Link
            data-test="nav-link"
            name={`nav ${pathName}`}
            to=""
            id={`nav_${pathName}`}
            key={`nav_${pathName}`}
            onClick={(e) => handleSelectPath(`/${pathName}`)}
            onFocus={(e) => handleFocus(e)}
          >
            <ListGroup.Item className="nav-icon" action>
              <FontAwesomeIcon
                icon={link.icon}
                title={`${link.title}`}
                size={isTablet ? "2x" : ".5x"}
              />
            </ListGroup.Item>
          </Link>
        ) : (
          <Link
            data-test="nav-link"
            name={`nav ${pathName}`}
            to={`/${pathName}`}
            id={`nav_${pathName}`}
            key={`nav_${pathName}`}
            onClick={(e) => handleSelectPath(`/${pathName}`)}
            onFocus={(e) => handleFocus(e)}
          >
            <ListGroup.Item className="nav-icon" action>
              <FontAwesomeIcon
                icon={link.icon}
                title={`${link.title}`}
                size={isTablet ? "2x" : ".5x"}
              />
            </ListGroup.Item>
          </Link>
        )}
      </OverlayTrigger>
    );
  });
}
